export default import.meta.ROLLDOWN_FILE_URL_7mycJGwmtobPiWujWW96Kw